import React from 'react';
import { NavItems } from './NavItems';
export const NavPane = () => {
    return (React.createElement("div", { className: "nav-pane" },
        React.createElement(NavItems, null)));
};
